<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Account Log', to: { path: '/account-log' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Account Log</h2>
      <v-spacer></v-spacer>
    </div>
    <!--  -->
    <AccountLogTable class="mb-5"></AccountLogTable>
  </div>
</template>

<script>
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import AccountLogTable from '@/views/M-2__AccountLog/c/AccountLogTable.vue';

export default {
  components: {
    BreadScrumbs,
    AccountLogTable,
  },
  methods: {
    createHandler() {
      this.$router.push('/edm-send-list/create');
    },
  },
};
</script>

<style></style>
